import React from "react";
import { Logo } from "./Logo";
import { Instagram, Twitter, Youtube, ArrowUpRight } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      className="relative bg-[color:var(--mati-sand)] border-t border-[color:var(--mati-border)] overflow-hidden"
      data-testid="site-footer"
    >
      <div className="max-w-[1360px] mx-auto px-5 sm:px-8 lg:px-12 pt-20 pb-12">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 lg:col-span-6">
            <div className="flex items-center gap-3">
              <Logo className="h-10 w-10" />
              <div className="font-mono-ui text-[11px] tracking-[0.32em] text-[color:var(--mati-muted)]">
                EST · 2025 · MORBI, GUJARAT
              </div>
            </div>
            <p className="mt-6 font-sub text-base text-[color:var(--mati-muted)] max-w-md leading-relaxed">
              A citizen-driven movement for a greener, healthier ceramic city.
              Compiled from Swachh Bharat Mission (Urban), MMC and Swachh
              Survekshan field reports.
            </p>
          </div>

          <div className="col-span-6 lg:col-span-3">
            <div className="eyebrow text-[color:var(--mati-forest)]">
              Explore
            </div>
            <ul className="mt-5 space-y-3 font-sub text-[15px]">
              {[
                ["#journey", "Journey"],
                ["#challenges", "Challenges"],
                ["#methods", "Playbook"],
                ["#impact", "Impact"],
                ["#pledge", "Pledge"],
              ].map(([href, label]) => (
                <li key={href}>
                  <a
                    href={href}
                    data-testid={`footer-link-${label.toLowerCase()}`}
                    className="inline-flex items-center gap-1 hover:text-[color:var(--mati-clay)] transition-colors"
                  >
                    {label}
                    <ArrowUpRight className="w-3.5 h-3.5" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 lg:col-span-3">
            <div className="eyebrow text-[color:var(--mati-forest)]">
              Follow
            </div>
            <ul className="mt-5 space-y-3 font-sub text-[15px]">
              <li className="flex items-center gap-2">
                <Instagram className="w-4 h-4" /> @mati.morbi
              </li>
              <li className="flex items-center gap-2">
                <Twitter className="w-4 h-4" /> @matimorbi
              </li>
              <li className="flex items-center gap-2">
                <Youtube className="w-4 h-4" /> MATI MORBI
              </li>
            </ul>
          </div>
        </div>

        {/* Massive wordmark */}
        <div className="mt-16 border-t border-[color:var(--mati-border)] pt-8">
          <div
            aria-hidden
            className="font-display font-extrabold text-[color:var(--mati-forest)] text-[22vw] leading-[0.85] tracking-[-0.04em] select-none"
          >
            MĀTI<span className="text-[color:var(--mati-clay)]">·</span>MORBI
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 font-mono-ui text-[10px] tracking-[0.28em] text-[color:var(--mati-muted)] uppercase">
          <div>© 2025 Māti Morbi · Civic Renewal Movement</div>
          <div>The Soil · The City · The Citizen</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
